// 结算的weblog
// https://radar-plus.corp.kuaishou.com/project/5802756d2b/dashboard?env=h5&timeRange=Last1Hour
import { Weblog, LoggerConfigByUser } from '@ks/weblogger/es/log.hybrid';
import Radar from '@ks/weblogger/lib/plugins/radar';

type LogConfigEnv = LoggerConfigByUser['env'];

const NODE_ENV = process.env.NODE_ENV as LogConfigEnv;
// 初始化 weblogger
const weblog = new Weblog(
  {
    env: NODE_ENV, // 正式环境
    autoPV: false, // 是否开启自动 PV 收集
    fps: false, // 是否开启 FPSMonitor，间隔统计网页的 FPS 信息
    // 配置插件
    plugins: [
      new Radar({
        //@ts-ignore 
        projectId: '1ae3e50669', // 雷达平台上的唯一标识
        sampling: 1, // 上报采样率，1 为全部上报
      }),
    ],
  },
  {
    product_name: 'KUAISHOU',
  }
);

// PV事件
const WEBLOG_PV = (
  // page: string,
  params: any = {},
  contentPackage: any = {}
) => {
  // const beginTime = new Date().valueOf();
  // 触发 enter 事件，通常只需要在 enter 时设置 page 和 params，其他 PV 事件会自动附带 enter 时的设置
  weblog.sendImmediately('PV', {
    type: 'enter',
    // page: page, // 设置当前进入页面的页面标识（在埋点平台注册，在 App 分析查看）
    params: params,
    contentPackage: contentPackage,
  });
};

// 元素展现
const WEBLOG_ELEMENT_SHOW = (
  action: string,
  params: any = {},
  contentPackage: any = {}
) => {
  weblog.sendImmediately('SHOW', {
    action: action,
    params: params,
    contentPackage: contentPackage,
  });
};

// CLICK事件
const WEBLOG_CLICK = (
  action: string,
  params: any = {},
  contentPackage: any = {}
) => {
  weblog.sendImmediately('CLICK', {
    action: action,
    params: params,
    contentPackage: contentPackage,
  });
};

// TASK事件
const WEBLOG_TASK = (
  action: string,
  params: any = {},
  contentPackage: any = {}
) => {
  weblog.sendImmediately('CLICK', {
    action: action,
    params: params,
    type: 'USER_OPERATION',
    contentPackage: contentPackage,
  });
};

// 更新信息
const WEBLOG_UPDATE_URL_PACKAGE = (params: {}) => {
  weblog.updateCurrentUrlPackage(params);
};

const RADAR_FMP = (timestamp?: number) => {
  if (weblog?.plugins?.radar) {
    weblog?.plugins?.radar.fmp(timestamp);
  }
};

const RADAR_EVENT = (name: string, params: any) => {
  if (weblog?.plugins?.radar) {
    weblog?.plugins?.radar.event({
      ...params,
      name: name,
    });
  }
};

export {
  weblog,
  WEBLOG_PV,
  WEBLOG_ELEMENT_SHOW,
  WEBLOG_CLICK,
  WEBLOG_TASK,
  WEBLOG_UPDATE_URL_PACKAGE,
  RADAR_FMP,
  RADAR_EVENT,
};
